





















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import controldto from "@/store/entities/Common/controldto";

@Component({
  components: {},
})
export default class ReplaceDeviceId extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: '' }) deviceId: string;
  controldto: controldto = new controldto();
  loading: boolean = false;
  create() { }
  created() { }
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let res = await this.$store
          .dispatch({
            type: "devicetenant/replaceISPDevice",
            data: this.controldto,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.$Modal.info({
          title: this.L("Tips"),
          content: res,
        });
        this.loading = false;
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  itemRule = {
    ispDeviceId: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  @Watch("deviceId")
  getitemId() {
    this.controldto.deviceId = this.deviceId;
  }
}
